import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TabsComponent } from '@vg-constellation/angular-16/tabs';
import { Subscription } from 'rxjs';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';
import { GRADES_11_12_MATERIALS } from '../materials/11-12.materials';

@Component({
  selector: 'grades11',
  templateUrl: './grades11-12.component.html',
  styleUrls: ['./grades11-12.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Grades1112Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('jobsTabs') jobsTabs: TabsComponent;
  @ViewChild('jobAssignmentTabs') jobAssignmentTabs: TabsComponent;
  @ViewChild('insuranceTabs') insuranceTabs: TabsComponent;
  private langChangeSubscription!: Subscription;
  grades1112Materials: GradeMaterials = GRADES_11_12_MATERIALS;

  @ViewChild('howWork') howWork!: ElementRef;
  @ViewChild('curStand') curStand!: ElementRef;
  @ViewChild('proOut') proOut!: ElementRef;
  @ViewChild('ecoSystem') ecoSystem!: ElementRef;
  @ViewChild('investing') investing!: ElementRef;
  @ViewChild('insurance') insurance!: ElementRef;
  @ViewChild('prepMat') prepMat!: ElementRef;
  @ViewChild('rewards') rewards!: ElementRef;
  @ViewChild('advMod') advMod!: ElementRef;
  @ViewChild('firstDay') firstDay!: ElementRef;
  @ViewChild('secondDay') secondDay!: ElementRef;
  @ViewChild('everyDay') everyDay!: ElementRef;
  @ViewChild('jobAss') jobAss!: ElementRef;
  @ViewChild('syllabus') syllabus!: ElementRef;
  @ViewChild('payAndAuc') payAndAuc!: ElementRef;
  @ViewChild('billday') billday!: ElementRef;
  @ViewChild('taxDay') taxDay!: ElementRef;
  @ViewChild('budgetDay') budgetDay!: ElementRef;
  @ViewChild('creditDay') creditDay!: ElementRef;
  @ViewChild('inflationDay') inflationDay!: ElementRef;
  @ViewChild('yearEnd') yearEnd!: ElementRef;
  @ViewChild('classMaterials') classMaterialsSection!: ElementRef;
  
  constructor(
    public modalService: ModalService,
    private readonly adobeLaunchService: AdobeLaunchService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Grades 11 to 12'
    });
    
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.updateTabLabels();
    });
  }

  ngAfterViewInit(): void {
    this.updateTabLabels();
  }

  private updateTabLabels(): void {
    [this.jobsTabs, this.jobAssignmentTabs, this.insuranceTabs]
      .forEach(tabComponent => {
        tabComponent?.menuData?.items?.forEach(tab => {
          tab.labelText = this.translateService.instant('grades.table.header.' + (tab.tabPanelId || ''));
        });
      });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      howWork: this.howWork,
      curStand: this.curStand,
      proOut: this.proOut,
      ecoSystem: this.ecoSystem,
      investing: this.investing,
      insurance: this.insurance,
      prepMat: this.prepMat,
      rewards: this.rewards,
      advMod: this.advMod,
      firstDay: this.firstDay,
      secondDay: this.secondDay,
      everyDay: this.everyDay,
      jobAss: this.jobAss,
      syllabus: this.syllabus,
      payAndAuc: this.payAndAuc,
      billday: this.billday,
      taxDay: this.taxDay,
      budgetDay: this.budgetDay,
      creditDay: this.creditDay,
      inflationDay: this.inflationDay,
      yearEnd: this.yearEnd,
      classMaterials: this.classMaterialsSection,
    };

    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }
}
